    import React from 'react'
    
    const HeadingOne = ({heading1}) => {
      return (
        <h2 className='heading1'>{heading1}</h2>
      )
    }
    
    export default HeadingOne